import React from "react"
import {
  FINANCE_TRANSACTIONS_HISTORY_VIEW,
  FINANCE_TRANSACTION_LIST_VIEW,
  FINANCIAL_JOURNAL_VIEW,
  NEW_TRANSACTION_VIEW,
} from "./route-list"
import DesktopSidebarLayout from "@/layouts/desktop-sidebar-layout/desktop-sidebar-layout.tsx"
import NoMenuLayout from "@/layouts/no-menu-layout/no-menu-layout.tsx"
const FinancePage = React.lazy(
  () => import("@/features/finance/views/finance-page/finance-page"),
)
const NewTransactionView = React.lazy(
  () =>
    import(
      "@/features/finance/views/new-transaction-view/new-transaction-view"
    ),
)
const TransactionHistoryPage = React.lazy(
  () =>
    import(
      "@/features/finance/views/transaction-history-page/transaction-history-page"
    ),
)
const TransactionView = React.lazy(
  () => import("@/features/finance/views/transaction-view/transaction-view"),
)

export const financeRoutes = [
  {
    path: FINANCIAL_JOURNAL_VIEW,
    element: <FinancePage />,
  },
  {
    path: FINANCE_TRANSACTIONS_HISTORY_VIEW,
    element: <TransactionHistoryPage />,
  },
  {
    path: NEW_TRANSACTION_VIEW,
    element: <NewTransactionView />,
  },
  {
    path: `${FINANCE_TRANSACTION_LIST_VIEW}/:transactionId`,
    element: <TransactionView />,
  },
]

const MOBILE_FINANCE_ROUTES = [
  {
    element: <NoMenuLayout />,
    children: financeRoutes,
  },
]

const DESKTOP_FINANCE_ROUTES = [
  {
    element: <DesktopSidebarLayout />,
    children: financeRoutes,
  },
]

export const getFinanceRoutes = (isDesktop: boolean) => {
  return isDesktop ? DESKTOP_FINANCE_ROUTES : MOBILE_FINANCE_ROUTES
}
